
<footer>
  <div class="shadow card d-flex flex-column compi-footer">
    <div class="container">
      <div
        class="d-flex justify-content-end py-3 container flex-md-row flex-column"
      >
       <ng-container *ngFor="let itemLegalFooter of legalFooterItems">
        <a
          [routerLink]="['/legal', itemLegalFooter.action]"
          class="me-4 mb-0 footer-brand"
          routerLinkActive="active"
          style="color: inherit;">
          {{ itemLegalFooter.label }}
        </a>
       </ng-container>

        <p class="me-4 mb-0 footer-brand">Compliance</p>
      </div>
    </div>

    <hr />

    <div class="container">
      <div class="row align-items-center gy-4">
        <div class="col-12 col-md-6 text-center text-md-start">
          <img
            src="https://intranet.ahorramas.com/wp-content/uploads/2023/04/ahora_isologo_horizontal_a_2235x1024px-320x104.jpg"
            alt="Ahora+"
            style="width: 7rem"
          />
          <p class="footer-brand mt-2">
            Ahorramas © 2023 Todos los derechos reservados
          </p>
        </div>

        <div
          class="col-12 col-md-6 d-flex flex-column flex-md-row align-items-center justify-content-md-end alto"
        >
          <div
            class="d-flex justify-content-center justify-content-md-end gap-3 mb-3 mb-md-0"
            *ngFor="let rrssItem of rrss"
          >

            <a [href]="rrssItem.url" target="_blank">
             <i class="fa-brands fa-lg social-icon me-2" [ngClass]="'fa-' + rrssItem.action"></i>
            </a>

          </div>

          <div
            class="footer-divider border-start mx-4 d-none d-md-block"
            style="height: 2.5rem"
          ></div>

          <div
            class="d-flex align-items-center justify-content-center justify-content-md-start"
          >
            <div class="footer-download-app me-3">Descarga la app</div>
            <a
              href="https://intranet.ahorramas.com/android.php"
              target="_blank"
              class="me-2"
            >
              <i class="fa-brands fa-google-play fa-lg social-icon"></i>
            </a>
            <a href="https://intranet.ahorramas.com/ios.php" target="_blank">
              <i class="fa-brands fa-apple fa-xl social-icon"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

</footer>
